export default [
	{  // 【产品】-【分类管理】
		path: 'website/product/type/list',
		name: 'm_product_type',
		meta: {
			title: '分类管理'
		},
		component: () => import('@/pages/product/product_type')
	},{  // 【产品】-【半成品】
		path: 'website/material/list',
		name: 'm_material',
		meta: {
			title: '半成品管理'
		},
		component: () => import('@/pages/product/material_list')
	},{  // 【产品】-【半成品】
		path: 'website/material/detail/:id',
		name: 'material_detail',
		meta: {
			title: '半成品详情'
		},
		props: route => route.params,
		component: () => import('@/pages/product/material_detail')
	},{  // 【产品】-【成品】
		path: 'website/product/list',
		name: 'm_product',
		meta: {
			title: '成品管理'
		},
		component: () => import('@/pages/product/product_list')
	}
];